import { Target, Magnet, Share2, TrendingUp, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { SERVICE_CARDS, scrollToId } from "../../lib/site";

const ICONS = { Target, Magnet, Share2, TrendingUp };

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-12 scroll-mt-20">
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-2xl space-y-4 mb-12 lg:mb-16">
        <Eyebrow>What We Do</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
          Four Ways We Fill Your Pipeline{" "}
          <span className="gradient-accent-text">With Ready Buyers</span>
        </h2>
        <p className="text-base sm:text-lg text-slate-300">
          Pick one service or let us run the whole growth engine. Either way, every
          rupee is tracked to a result.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICE_CARDS.map((card, i) => {
          const Icon = ICONS[card.icon];
          return (
            <Reveal key={card.id} delay={i * 0.1}>
              <div
                data-testid={`service-card-${card.id}`}
                className="group h-full glass-card rounded-2xl p-6 sm:p-7 flex flex-col hover:bg-[#111C3D]/80 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(59,130,246,0.18)] transition-[transform,box-shadow,background-color] duration-300"
              >
                <div className="w-12 h-12 rounded-xl gradient-bg flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <Icon size={22} className="text-white" />
                </div>
                <h3 className="font-display text-xl font-semibold tracking-tight text-white">
                  {card.title}
                </h3>
                <span className="mt-2 inline-flex w-fit text-[11px] font-mono2 font-semibold text-emerald-400 bg-emerald-400/10 border border-emerald-400/20 rounded-full px-2.5 py-1">
                  {card.stat}
                </span>
                <p className="mt-3 text-sm text-slate-300 leading-relaxed flex-1">{card.copy}</p>
                <button
                  data-testid={`service-cta-${card.id}`}
                  onClick={() => scrollToId("lead-form")}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-400 hover:text-cyan-300 transition-colors duration-200"
                >
                  Get Started
                  <ArrowUpRight
                    size={16}
                    className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"
                  />
                </button>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
